/** @format */

import React from 'react'

export interface ValueWithUnitProps {
  value?: React.ReactNode
  unit?: string
}

/** MetricCard 数值 + 单位后缀 */
const ValueWithUnit: React.FC<ValueWithUnitProps> = ({ value, unit }) => (
  <>
    {value}
    {unit ? <span className="metric-card__suffix">{unit}</span> : null}
  </>
)

export default ValueWithUnit
